// extracted by mini-css-extract-plugin
export default {"Companies":"Companies_Companies__6AMKK","Record":"Companies_Record__eZzKV"};